// The signup app is the same build as the dashboard, served on `signup.dashboard.curatedplanet.com`,
// `signup.dashboard-staging.curatedplanet.com` and locally `signup.cp.devel:3000` (plan §16). `signup`
// is a reserved tenant code (backend demo/lib/sandbox/tenants.py), so no tenant dashboard has it.

export const SIGNUP_HOST_LABEL = 'signup';

/** True when the host's first DNS label is `signup`. */
export function isSignupHost(hostname: string = window.location.hostname): boolean {
    return (hostname || '').split('.')[0].toLowerCase() === SIGNUP_HOST_LABEL;
}

/** The new tenant's dashboard address for a code: the signup host with its first label replaced
 *  (`signup.dashboard.curatedplanet.com` → `acme.dashboard.curatedplanet.com`). */
export function tenantDashboardHost(code: string, host: string = window.location.host): string {
    const rest = (host || '').split('.').slice(1).join('.');
    return rest ? `${code}.${rest}` : code;
}
